// extracted by mini-css-extract-plugin
export var attachment = "_lk-a";
export var emailContainer = "_lk-4";
export var emailContentPaddedContainer = "_lk-b";
export var emailHeader = "_lk-6";
export var emailIframe = "_lk-3";
export var emailInfoIcon = "_lk-9";
export var emailShortenedSummary = "_lk-e";
export var infoDropdown = "_lk-0";
export var infoRowBoundedContent = "_lk-d";
export var internal = "_lk-5";
export var merchant = "_lk-8";
export var messageInputContainer = "_lk-h";
export var normal = "_lk-7";
export var replyCard = "_lk-f";
export var subtleButton = "_lk-1";
export var subtleButtonIconContainer = "_lk-2";
export var toggleViewRepliesButton = "_lk-c";
export var wrappingText = "_lk-g";